'use client'

import { FooterQueryResult } from '@repo/sanity/types'
import { Button } from '@repo/ui/components/button'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@repo/ui/components/hover-card'
import { FunctionComponent } from 'react'
import useLocaleChange from '../../../hooks/useLocaleChange.hook'
import { PageDto } from '../../../types/page.types'
import LinkResolver from '../../links/LinkResolver'
import LocaleButtons from '../LocaleButtonGroup'

interface Props {
  pageDto: PageDto
  footerLinks: NonNullable<FooterQueryResult>['footerLinks']
}

const FooterLinksRow: FunctionComponent<Props> = ({ pageDto, footerLinks }) => {
  const { changeLocale, isLoading } = useLocaleChange(pageDto.params.locale)

  return (
    <div className='hidden lg:block'>
      <ul className='whitespace-nowrap'>
        <li className='inline'>
          <HoverCard>
            <HoverCardTrigger asChild={true}>
              <Button variant='ghostAuto'>
                {pageDto.dictionary?.footer?.currency || 'Currency:'} {pageDto.marketInstance.currency}
              </Button>
            </HoverCardTrigger>
            <HoverCardContent className='min-w-32'>
              <LocaleButtons className='flex-col' locale={pageDto.params.locale} isLoading={isLoading} onChange={(newLocale) => changeLocale(newLocale)} />
            </HoverCardContent>
          </HoverCard>
        </li>
        {footerLinks?.map((footerLink) => {
          return (
            <li className='inline' key={footerLink._key}>
              <Button variant='ghostAuto' asChild={true}>
                <LinkResolver link={footerLink} locale={pageDto.params.locale}>
                  {footerLink?.label}
                </LinkResolver>
              </Button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default FooterLinksRow
